import React from 'react';
import { Icon } from '../icon';
import { ItemLabel, MenuItemRoot } from './Menu.styled';
import { DropdownOption } from './types';
import { Tooltip } from '../tooltip';

export function MenuItem<T extends React.Key>({
	icon,
	label,
	selected,
	onSelect,
	disabled,
	value,
	message,
	highlighted,
	originalIndex,
}: DropdownOption<T> & { highlighted?: boolean; originalIndex?: number }) {
	const onClick = () => !disabled && onSelect?.();
	return <Tooltip message={message} placement={'top'}>
		<MenuItemRoot 
			onClick={onClick} 
			$selected={selected} 
			$disabled={disabled} 
			$highlighted={highlighted} 
			data-value={value} 
			data-original-index={originalIndex}>
			{icon && <Icon icon={icon} />}
			<ItemLabel $disabled={disabled}>{label}</ItemLabel>
		</MenuItemRoot>
	</Tooltip>;
}
